module.exports = __webpack_public_path__ + "static/media/modernteak.efba5e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deck/modernteak.jpg
// module id = 109
// module chunks = 0